/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SqsMessage } from '../../models/sqs-message';
import { SqsMessagePagedResult } from '../../models/sqs-message-paged-result';

export interface MonitorSearchSqsMessagesSearchSqsMessagesPost$Params {
  pageNumber?: number;
  pageSize?: number;
      body?: SqsMessage
}

export function monitorSearchSqsMessagesSearchSqsMessagesPost(http: HttpClient, rootUrl: string, params?: MonitorSearchSqsMessagesSearchSqsMessagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SqsMessagePagedResult>> {
  const rb = new RequestBuilder(rootUrl, monitorSearchSqsMessagesSearchSqsMessagesPost.PATH, 'post');
  if (params) {
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SqsMessagePagedResult>;
    })
  );
}

monitorSearchSqsMessagesSearchSqsMessagesPost.PATH = '/Monitor/SearchSqsMessages/search-sqs-messages';
